import { IconsProps } from './IconsProps';

const Cart = ({
  className = '',
  viewBox = '0 0 36 36',
  width = 36,
  height = 36,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path d="M14.2549 25.592C13.8189 25.592 13.3927 25.7212 13.0302 25.9634C12.6678 26.2057 12.3853 26.5501 12.2185 26.9528C12.0517 27.3556 12.0081 27.7988 12.0932 28.2264C12.1783 28.6539 12.3882 29.0467 12.6965 29.3549C13.0048 29.6631 13.3976 29.8729 13.8251 29.9579C14.2527 30.0429 14.6959 29.9993 15.0986 29.8324C15.5013 29.6655 15.8456 29.3829 16.0877 29.0203C16.3298 28.6578 16.459 28.2316 16.4589 27.7956C16.4582 27.2113 16.2258 26.6511 15.8126 26.238C15.3994 25.8248 14.8392 25.5926 14.2549 25.592Z" />
      <path d="M25.5763 25.592C25.1403 25.592 24.7141 25.7212 24.3517 25.9634C23.9892 26.2056 23.7066 26.5498 23.5398 26.9526C23.373 27.3553 23.3294 27.7985 23.4145 28.2261C23.4995 28.6536 23.7095 29.0466 24.0178 29.3548C24.3261 29.6631 24.7188 29.8728 25.1464 29.9578C25.574 30.0428 26.0172 29.9992 26.4199 29.8323C26.8226 29.6654 27.1669 29.3828 27.409 29.0203C27.6511 28.6577 27.7803 28.2315 27.7802 27.7955C27.7796 27.2113 27.5471 26.651 27.1339 26.2379C26.7207 25.8248 26.1606 25.5925 25.5763 25.592Z" />
      <path d="M32.021 9.54372C31.9588 9.45619 31.8766 9.38493 31.7811 9.33561C31.6857 9.2863 31.5799 9.26044 31.4725 9.2603H9.5558L8.75316 6.48614C8.7127 6.34602 8.62781 6.22281 8.51126 6.13514C8.39471 6.04747 8.25285 6.00003 8.10701 6H3.67272C3.49431 6 3.32318 6.07093 3.19702 6.19708C3.07087 6.32324 3 6.49425 3 6.67266C3 6.85107 3.07087 7.02232 3.19702 7.14847C3.32318 7.27463 3.49431 7.34555 3.67272 7.34555H7.60081L12.2317 23.3505C12.2722 23.4906 12.3571 23.6136 12.4737 23.7013C12.5902 23.7889 12.7321 23.8364 12.8779 23.8364H27.0918C27.2702 23.8364 27.4412 23.7657 27.5674 23.6396C27.6936 23.5134 27.7644 23.3422 27.7644 23.1637C27.7644 22.9853 27.6936 22.8143 27.5674 22.6882C27.4412 22.562 27.2702 22.4911 27.0918 22.4911H13.3841L12.841 20.6141H27.9813C28.121 20.6141 28.2572 20.5707 28.3711 20.4898C28.4849 20.4088 28.5708 20.2944 28.6167 20.1625L32.1079 10.1544C32.1432 10.0531 32.1537 9.94488 32.1386 9.83864C32.1235 9.73241 32.0832 9.63119 32.021 9.54372Z" />
    </svg>
  );
};

export default Cart;
